import { render, staticRenderFns } from "./ExportAccordionColors.vue?vue&type=template&id=16171393&"
import script from "./ExportAccordionColors.vue?vue&type=script&lang=js&"
export * from "./ExportAccordionColors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports